<template>
  <div class="card-media">
    <div :style="styles" class="card-media__image" />
    <slot />
  </div>
</template>

<script>
import { convertToUnit } from "@utils/helpers";

export default {
  name: "CardMedia",
  props: {
    src: {
      validator: prop => typeof prop === "string" || prop === null
    },
    height: {
      type: [Number, String],
      required: true
    },
    triangles: Boolean
  },

  computed: {
    styles() {
      return {
        "background-image": this.src ? `url('${this.src}')` : "",
        height: convertToUnit(this.height)
      };
    }
  }
};
</script>

<style lang="scss">
$color: #fff;

.card-media {
  position: relative;
  &__image {
    background: colors(palette-7) no-repeat center;
    background-size: cover;
    width: 100%;
    height: 100px;
    border-radius: inherit;
    transition: 0.3s;
  }
}
</style>
